import {FC} from 'react'
import s from './index.module.scss'
import PlaneIcon from './plane.react.svg'

type Props = {
  data: any
}

const Prices: FC<Props> = ({data}) => {

  return (
    <div className={s.root}>
      <h2 className={s.title}>
        {data.title ? data.title : 'Experience the open future of aviation.'}
      </h2>
      {data.text ? (
        <div className={s.summary} dangerouslySetInnerHTML={{__html: data.text}}/>
      ) : null}
      <div className={s.list}>
        {data?.cards.map((item: any, index: number) => (
          <div className={index % 2 === 0 ? s.image :  s.image2} key={index} style={{backgroundImage: `url(${item?.image})`}}>
            <div className={s.content}>
              <p className={s.date}>{item?.date || ''}</p>
              <div className={s.bannerTitle}>
                {item?.from  || ''} <img alt='' aria-hidden={true} src={PlaneIcon}/><br/>
                {item?.to  || ''}
              </div>
              <p className={s.text}>
                <span dangerouslySetInnerHTML={{ __html: item?.priceText || 'Price for the seat as low as'}} />
                <b className={s.gap}>{item?.price}</b>
              </p>
            </div>
            <a  rel="noreferrer" className={s.link} target='_blank' href={item.link}>Register to book</a>
          </div>
        ))}
      </div>
    </ div>
  )
}

export default Prices
